// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import GardenAdviceSchema from './garden-advice-schema';
import GardenCertificationSchema from './garden-certification-schema';
import NimSContactDataSchema from './nim-s-contact-data-schema';
import AddressSchema from './address-schema';
import NimSContactCommunicationSchema from './nim-s-contact-communication-schema';
import RequestSummarySchema from './request-summary-schema';

const schema = {
  $id: '/create-nim-s-registration-request-schema',
  type: 'object',
  required: [],
  properties: {
    natureOffer: {
      type: 'string',
      format: 'uuid',
    },
    gardenAdvice: {
      ...GardenAdviceSchema,
    },
    gardenCertification: {
      ...GardenCertificationSchema,
    },
    remarks: {
      type: 'string',
      nullable: true,
    },
    gardenSize: {
      type: 'integer',
      nullable: true,
    },
    gardenType: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    isGardenOwner: {
      type: 'boolean',
    },
    hasAcceptedRegulations: {
      type: 'boolean',
    },
    contactData: {
      ...NimSContactDataSchema,
    },
    isGardenAddressNotContactDataAddress: {
      type: 'boolean',
    },
    gardenAddress: {
      ...AddressSchema,
    },
    communicationData: {
      ...NimSContactCommunicationSchema,
    },
    communicationTime: {
      type: 'string',
      nullable: true,
    },
    nimSLanguageId: {
      type: 'string',
      format: 'uuid',
    },
    userLanguage: {
      type: 'string',
      nullable: true,
    },
    hasAcceptedMarketing: {
      type: 'boolean',
    },
    summary: {
      ...RequestSummarySchema,
    },
    hasAcceptedGdpr: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
